import { Flip, toast } from 'react-toastify';

//to define the gender 
export const handleDefineGender = ( gender )=>{
    if( gender === "MALE" ){
      return "ذكر";
    }
    else if( gender === "FEMALE" ){
      return "أنثى";
    }
    else{
      return "غير محدد";
    }
   }


//handle the date format 
export const formatDate = (isoDate) => {
 const date = new Date(isoDate);
 const year = date.getUTCFullYear();
 const month = String(date.getUTCMonth() + 1).padStart(2, '0');
 const day = String(date.getUTCDate()).padStart(2, '0');
  
    return `${year}-${month}-${day}`;
  };
 

//Status of relative data
export const statusOfRelativeData = (status)=>{
    if( status === "WAITING" ){
      return "قيد المراجعة";
    }
    else if( status === "DENIED" ){
      return "مرفوضة";
    }
    else if( status === "ACCEPTED" ){
      return "مقبول";
    }
    else if( status === "RETURNED" ){
      return "معادة";
    }
  }    

//get four days before today
export const getDateFourDaysAgo = () => {
     const date = new Date();
     date.setDate(date.getDate() - 4);
     return date.toISOString().split('T')[0];
   }     


//vacation type define
export const handelVacatinTypeShow = (vacaType)=>{
  if(vacaType === "DEFAULT"){
      return "عادية";
  }

  else if(vacaType === "DEATH"){
     return "اجازة وفاة";
  }
  else if(vacaType === "MARRIAGE"){
       return "اجازة زواج";
    }
  else if(vacaType === "MISSION"){
         return "مهمة";
      }
  else if(vacaType === "EXIT_PERMISSION"){
           return "اذن حروج";
        }
  else 
    return "عادية";
}


//check the status of the vacation
export const vacationStatusCheck = (vacaStatus)=>{
    if( vacaStatus === "WAITING_FOR_MANAGER_ACCEPT" )
        return "بانتظار موافقة مدير القسم";
    else if( vacaStatus === "WAITING_FOR_HR_ACCEPT" )
        return "بانتظار موافقة الموارد البشرية";
    else if( vacaStatus === "WAITING_FOR_DOOR_OFFICER_ACCEPT" )
      return "بانتظار موافقة الحرس";
    else if( vacaStatus === "ACCEPTED" )
        return "تم الموافقة عليها";
    else if( vacaStatus === "DENIED_FROM_MANAGER" )
      return "تم رفضها من قبل المدير";
    else if( vacaStatus === "DENIED_FROM_HR" )
      return "تم رفضها من قبل الموارد البشرية";
    else if( vacaStatus === "DENIED_FROM_DOOR_OFFICER" )
      return "تم رفضها من موظف الباب الخارجي";  

  }


//format the date and get the hours and minutes 
export const getTheHoursAndMinutes = (vacaDate)=>{
    const dateObj = new Date(vacaDate);

    const hours = dateObj.getUTCHours();       // 15
    const minutes = dateObj.getUTCMinutes();   // 20  

    return `${hours}:${minutes}`;
  }

//to put comma every three digits (for money)
export const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}   


//function to show the add btn in to add relatives or not show it 
export const showTheAddRelativeBtn = ( obj )=>{
  if( obj?.marital_status === "SINGLE" ){
    return false;
  }
  else{
    return true;
  }
}


//check if the emp have been in the company for more than six monthes
export const checkHiringDateBiggerThanSixMonthes = ( obj )=>{
    if( obj?.hiring_date ){
     return checkMoreThanSixMonthes(obj?.hiring_date);
    }
    return false;
  }
  
const checkMoreThanSixMonthes = ( hiringDateStr )=>{
    const hiringDate = new Date(hiringDateStr);
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
  
    return hiringDate <= sixMonthsAgo;
  }

//check if the someone have been in the company between the six monthes and 8 monthes only ( no more than 6 monthes )  
export const checkHiringDateBetweenSixMonthesAndEightMonthes = ( hiringDateStr )=>{
  const hiringDate = new Date(hiringDateStr);
  const sixMonthsAgo = new Date();
  sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);

  const eightMonthsAgo = new Date();
  eightMonthsAgo.setMonth(eightMonthsAgo.getMonth() - 8);  
  return hiringDate <= sixMonthsAgo && hiringDate >= eightMonthsAgo ; 
  //if a date is lower than another date it means this date is more old than the other one
}

//for the noftify ( toast )
export const notifyToast = ( status , text ) =>
  {
   if( status === "WAITING" ){
   return(
     toast.info( text , {
       position: "bottom-right",
       autoClose: 5000,
       hideProgressBar: false,
       closeOnClick: false,
       pauseOnHover: true,
       draggable: true,
       progress: undefined,
       theme: "light",
       transition: Flip,
       style : {color:"blue"}
       })
   )
 }
  else if (status === "SUCCESS"){
   return(
     toast.success( text , {
       position: "bottom-right",
       autoClose: 5000,
       hideProgressBar: false,
       closeOnClick: false,
       pauseOnHover: true,
       draggable: true,
       progress: undefined,
       theme: "light",
       transition: Flip,
       style : {color:"green"}
       })
   )
  }

  else if (status === "ERROR"){
    return(
      toast.error( text , {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Flip,
        style : {color:"red"}
        })
    )
   }  
  }


//calculate the years for the health inc 
export const calcYears = ( fullMonths )=>{
let years = Math.floor( Number(fullMonths) / 12 ); 
let months = Number(fullMonths) % 12; 

return {
  years ,
  months
}
} 

//to shorten the file name and show only the first 15 letters of the name with the extenision of the file
export const getShortFileName = ( fileName ) => {
    const maxBaseLength = 10; // adjust based on your UI width
    const dotIndex = fileName.lastIndexOf(".");
  
    if (dotIndex === -1) return fileName; // no extension found
  
    const name = fileName.substring(0, dotIndex);
    const ext = fileName.substring(dotIndex);
  
    if (name.length > maxBaseLength) {
      return name.substring(0, maxBaseLength) + "_" + ext;
    } else {
      return name + ext;
    }
  };  


//compare file size to the size that is less that or equal to required size by mb
export const compareFileSize = ( fileSize , reqSize ) => {

const MAX_FILE_SIZE_MB = reqSize ;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

if ( fileSize > MAX_FILE_SIZE_BYTES) {
  return false;
}
else{
  return true;
}
}


//to show a short cut of  a vacation's reason
export const TruncatedText = (text, maxLength ) => {
  const truncatedText = text.length > maxLength ? `${text.split(' ')[0]}...` : text;

  return <>{truncatedText}</>
};


//to calculate the remain balance
export const calculateTheRemainBalance = ( bills = [] , fullBalance = 0 ) => {
let sum = 0 ;
for( let i = 0 ; i < bills.length  ; i++ ){
  if( bills[i].paid_by_company === false ){
   sum += bills[i].balance ;
  }
}

let remainBalance = fullBalance - sum;

return numberWithCommas(remainBalance);
}


//to handle the model type in the health inc stat
 export const handleModelType = ( type )=>{
        if( type === "Employee" )
            return "الموظين";
        else if(type === "Relative")
            return "الاقارب";
    }


//to generate light color depending on the id or the number you are sending to me 
export const generateLightColor = ( id = 0 ) =>{
    const colors = [
      "#FFEBEE",
      "#E8F5E9",
      "#E3F2FD",
      "#FFF3E0",
      "#F3E5F5",
      "#F1F8E9",
      "#E0F7FA",
      "#FFFDE7",
      "#FBE9E7",
      "#ECEFF1",
      "#F9FBE7",
      "#FCE4EC",
    ];

    return colors[id % colors.length];
  }
